import { Box, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { SingleTermSearch } from 'app/components/forms/single-term-search';
import { RequestCards } from 'app/components/request-cards';
import { SeamStatus } from 'app/constants';
import { CrisRequest } from 'app/model';
import { AppDispatch } from 'app/store';

import { fetchCrisRequests, setCurrentCrisRequest } from './cris.slice';

const COLUMNS = [
    {
        header: 'Taxonomy Check',
        statuses: [SeamStatus.TXN_CHECK],
    },
    {
        header: 'For Assignment',
        statuses: [SeamStatus.ASSIGN],
    },
    {
        header: 'Mid Matching',
        statuses: [SeamStatus.MIDMATCHING],
    },
    {
        header: 'QA',
        statuses: [SeamStatus.QA],
    },
];

export const Kanban: React.FunctionComponent = () => {
    const history = useHistory();
    const dispatch = useDispatch<AppDispatch>();

    const [term, setTerm] = useState('');
    const [requests, setRequests] = useState<CrisRequest[][]>(COLUMNS.map(() => []));

    const openRequest = useCallback(
        (request: CrisRequest) => {
            dispatch(setCurrentCrisRequest(request));
            history.push(`/cris/request/${request.id || ''}`);
        },
        [dispatch, history],
    );

    useEffect(() => {
        COLUMNS.forEach((data, index) => {
            dispatch(fetchCrisRequests({ status: data.statuses, term })).subscribe((value) => {
                setRequests((current) => current.map((item, key) => (key === index ? value.data : item)));
            });
        });
    }, [dispatch, term]);

    return (
        <>
            <SingleTermSearch onSubmit={setTerm} />
            <Grid container spacing={2}>
                {COLUMNS.map((data, index) => (
                    <Grid item xs={3} key={index}>
                        <Typography className='p-1' sx={{ backgroundColor: 'success.light' }}>
                            {data.header}
                        </Typography>
                    </Grid>
                ))}
                {COLUMNS.map((data, index) => (
                    <Grid item xs={3} key={index}>
                        <Box
                            sx={{
                                backgroundColor: 'lightgray',
                                height: '500px',
                                overflow: 'auto',
                            }}
                        >
                            <RequestCards
                                requests={requests[index]}
                                onSelect={(request: CrisRequest) => openRequest(request)}
                                cardClass='mb-1'
                            />
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};
